<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/q6haBp/tc-custom/9781398418530.jpg?1731054761078" alt="This image is the cover for the book Simple Sayings From The Bad Rabbit"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Simple Sayings From The Bad Rabbit
      </h1>
      <p class="bookDescription body article font2">
        <p>The Bad Rabbit and his friends impart universal truths and simple wisdom on how to live one’s life for children and their parents. These are individually presented through situations the Bad Rabbit and his friends find themselves in, which in turn can be humorous, loving, scary or profound. Although the Rabbit and his closest confidants can be mischievous or downright naughty, there is always the constant thread of love and loyalty across all the friends. As we know, life can get a little bit too serious without a healthy dose of humour and the ability to laugh at ourselves. Simple Sayings is the third and final volume, following Life Lessons from the Bad Rabbit and Wise Words from the Bad Rabbit.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alexander George
      </h2>
      
      <p class="authorDescription body article">Alexander George is a Scotsman who now lives in Glasgow after spending 20 years in Cape Town. He is married and has a young daughter, Islay, who was the inspiration behind the Bad Rabbit. The drawings were originally conceived as part of a ritual of producing ‘love letters’ to place into his daughter’s schoolbag. Simple Sayings from The Bad Rabbits is the third and final volume of the Bad Rabbit series, following Life Lessons and Wise Words from the Bad Rabbit.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05f0424a